// src/features/executive/account/hooks/use-expense-category.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import AccountApi from 'api/executive/account.api'
import type {
  ExpenseCategoryResponse,
  GetExpenseCategoryParams,
} from 'api/executive/executive.types'

export function useExpenseCategory() {
  return useExecutiveQuery<GetExpenseCategoryParams, ExpenseCategoryResponse>(
    'account.expense-category',
    AccountApi.getExpenseCategory,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      // Expense category: no paymentType filter per spec matrix.
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
      }
    }
  )
}
